import api from "../api";

export default function countEntities() {
    return api.get(`/admin/countEntities`);
}
